import styled from "@emotion/styled"
import { readableColor } from "polished"

import { rhythm } from "@utils/typography"

const Table = styled.table`
  border-collapse: collapse;
  border-spacing: 0;
  margin: ${rhythm(1)} 0;
  padding: 0;
  width: 100%;
`

const Thead = styled.thead`
  background: ${props => props.background || props.theme.backgroundColor};
  color: ${props => readableColor(props.background || props.theme.backgroundColor)};
  visibility: hidden;
  ${props => props.theme.mq[2]} {
    visibility: visible;
  }
`

const Tbody = styled.tbody``

const Tr = styled.tr`
  background: ${props => props.background || props.theme.color};
  color: ${props => readableColor(props.background || props.theme.color)};
  border-bottom: 2px solid ${props => props.theme.color};
  display: block;
  margin-bottom: ${rhythm(1 / 2)};
  padding: ${rhythm(1 / 4)};
  ${props => props.theme.mq[2]} {
    display: table-row;
    border-bottom-width: 1px;
    margin-bottom: 0;
  }
`

const Td = styled.td`
  border-bottom: 1px dotted ${props => props.theme.color};
  display: block;
  padding: ${rhythm(1 / 2)}!important;
  text-align: right;
  &:last-child {
    border-bottom: none;
  }
  ${props => props.theme.mq[2]} {
    border-bottom: 0;
    display: table-cell;
    text-align: center;
  }

  &:before {
    content: attr(data-label);
    float: left;
    font-weight: 700;
    text-transform: uppercase;
    ${props => props.theme.mq[2]} {
      content: "";
      display: none;
    }
  }
`

const Th = styled.th`
  padding: ${rhythm(1 / 2)}!important;
  text-align: center;
  text-transform: uppercase;
`

export { Table, Thead, Tbody, Tr, Th, Td }
